// Safari (iOS/macOS) wirft bei „Alle Cookies blockieren“ / gesperrtem Website-Speicher einen
// SecurityError beim bloßen Zugriff auf window.localStorage → React-Baum stürzt ab → weißer Bildschirm.
// Hier wird in diesem Fall ein In-Memory-Ersatz eingehängt, damit die App weiterhin rendert.
function createMemoryStorage() {
  const data = new Map();
  return {
    get length() { return data.size; },
    key(i) { return Array.from(data.keys())[i] ?? null; },
    getItem(k) { return data.has(String(k)) ? data.get(String(k)) : null; },
    setItem(k, v) { data.set(String(k), String(v)); },
    removeItem(k) { data.delete(String(k)); },
    clear() { data.clear(); },
  };
}

function storageUsable(name) {
  try {
    const s = window[name];
    if (!s) return false;
    const probe = '__gle_storage_probe__';
    s.setItem(probe, '1');
    s.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

export function installSafeStorage() {
  if (typeof window === 'undefined') return { localStorage: true, sessionStorage: true };
  const result = {};
  for (const name of ['localStorage', 'sessionStorage']) {
    result[name] = storageUsable(name);
    if (result[name]) continue;
    try {
      Object.defineProperty(window, name, { value: createMemoryStorage(), configurable: true, writable: false });
    } catch { /* nicht überschreibbar → Zugriffe müssen selbst abgesichert sein */ }
    window.__gle_storage_fallback = { ...(window.__gle_storage_fallback || {}), [name]: true };
  }
  return result;
}

installSafeStorage();
